import app from '../../scripts/app';
import template from './price-alert.jade';
import { events as priceEstimatorEvents } from '../../scripts/services/price-estimator.service/events';

app.directive('cianAfPriceAlert', [
  'priceLimitService',
  '$rootScope',
  () => ({
    template,
    scope: {},
    bindToController: {
      userPrice: '@',
    },
    controller: [
      '$scope',
      '$timeout',
      function ($scope, $timeout) {
        this.alertTimeout = null;
        this.isVisible = true;
        this.middlePrice = 0;

        this.stopOnMiddlePriceUpdated = $scope.$on(priceEstimatorEvents.ESTIMATED_PRICE_UPDATED, (event, price) => {
          this.middlePrice = price.value;
        });

        this.stopOnPricesChanged = $scope.$watchGroup([() => this.userPrice, () => this.middlePrice], values => {
          const userPrice = Number(values[0]);
          const middlePrice = Number(values[1]);
          if (userPrice > 0 && middlePrice > 0 && Math.abs(userPrice - middlePrice) > middlePrice / 2) {
            if (!this.isVisible) {
              if (this.alertTimeout) {
                $timeout.cancel(this.alertTimeout);
              }
              this.alertTimeout = $timeout(() => {
                this.isVisible = true;
              }, 1500);
            }
          } else {
            this.isVisible = false;
          }
        });

        this.close = () => {
          this.isVisible = false;
          this.stopOnPricesChanged();
          this.stopOnMiddlePriceUpdated();
        };
      },
    ],
    controllerAs: 'priceAlert',
  }),
]);
